export class CostReviewSecurityEnUsExecutionSchedule {
  isExecutionScheduleChecked!: boolean;
  phasedInstallation!: number;
  describePhasingConsiderations!: string;
  projectSchedulePublished!: number;
  officeTechnicalCompetencies!: number;
  localOfficeStaffed!: number;
  specialTaggingRequirements!: number;
  specialCutoverRequirements!: number;
}
